module.exports = __webpack_public_path__ + "ptc_nakagawa_B1.486d5cab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_B1.jpg
// module id = 7pAJ
// module chunks = 0